<!-- Editable -->
@if (editable) {
    <div id="item-stars">
        @for (star of stars; track star; let i = $index) {
            <div
                [ngClass]="{ me: view === 'me', pointer: editable === true }"
                [id]="i"
                (click)="setStar(i)"
                (mouseenter)="enterMouse($event)"
                (mouseleave)="leaveMouse($event)"
            >
                @if (star === "X") {
                    <mat-icon class="golden">star</mat-icon>
                }
                @if (star === "-") {
                    <mat-icon class="gray">star</mat-icon>
                }
            </div>
        }
    </div>
}

<!-- Static -->
@if (!editable) {
    <div id="item-stars">
        @for (star of stars; track star; let i = $index) {
            <div [ngClass]="{ me: view === 'me', pointer: editable === true }" [id]="i">
                @if (star === "X") {
                    <mat-icon class="golden">star</mat-icon>
                }
                @if (star === "-") {
                    <mat-icon class="gray">star</mat-icon>
                }
            </div>
        }
    </div>
}
